import Brands from "../components/LandingPage/Brands";
import Testimonials from "../components/LandingPage/Testimonials";
import BlivFrasekonsulent from "../components/Team/BlivFrasekonsulent";
import EjereGrid from "../components/Team/EjereGrid";
import FraseDoktor from "../components/Team/FraseDoktor";
import HeroSection from "../components/Team/HeroSection";
import SammarbejdsPartner from "../components/Team/SammarbejdsPartner";
import PublicLayout from "../layout/PublicLayout";

export default function Team() {
  return (
    <PublicLayout>
      <HeroSection />
      <EjereGrid />
      <FraseDoktor />
      <SammarbejdsPartner />
      <BlivFrasekonsulent />
      <Testimonials />
      <Brands />
    </PublicLayout>
  );
}
